<template>
  <sui-modal class="wrapper" v-model="visible" :closable="false" :style="{zIndex}">
    <sui-modal-header class="header">
      Update service
    </sui-modal-header>
    <sui-modal-content :scrolling="scrolling">
      <sui-form warning :error="hasApiErrors" :loading="loading" @submit.prevent="submit()" v-if="entity">
        <sui-message warning icon="warning sign" v-if="isRestricted">
          <router-link class="ui green right floated button" to="/settings/plans" @click.native="close()">Change plan</router-link>
          Changing the log provider<br>is not available on your plan!<br>
        </sui-message>
        <FormService ref="formService" v-model="entity" :mode="mode" />
        <sui-message error>
          {{apiErrors}}
        </sui-message>
      </sui-form>
    </sui-modal-content>
    <sui-modal-actions>
      <div class="ui buttons">
        <sui-button icon="check" label-position="left" color="green" :disabled="isRestricted || loading || hasEntityErrors || !hasChanges || !actions.serviceUpdate" @click="submit()" :data-goal="`${goalPrefix}_TRY`">Confirm</sui-button>
        <sui-button icon="ban" label-position="right" color="red" @click="cancel()">Cancel</sui-button>
      </div>
    </sui-modal-actions>
    <sui-dimmer class="dimmer" :active="success" inverted>
      <h2 class="ui icon header">
        <i class="green check circle icon" />
        Updating started
      </h2>
    </sui-dimmer>
  </sui-modal>
</template>

<script>
  import {mapGetters} from 'vuex'
  import cloneDeep from 'lodash/cloneDeep'
  import FormService from '@/components/forms/Service'
  import ModalForm from '@/mixins/ModalForm'
  import utils from '@/utils'

  export default {
    name: 'ModalUpdateService',
    mixins: [
      ModalForm,
    ],
    components: {
      FormService,
    },
    data() {
      return {
        newMode: 'updating',
      }
    },
    computed: {
      ...mapGetters(['account', 'actionsById']),
      actions() {
        return this.actionsById[this.entity.id] || {}
      },
      mode() {
        return this.newMode || 'updating'
      },
      goalPrefix() {
        switch(this.mode) {
          case 'updating': return 'UPDATE_SERVICE'
          case 'resetingPassword': return 'UPDATE_SERVICE_PASSWORD'
          case 'updatingLogProvider': return 'UPDATE_SERVICE_LOGPROVIDER'
          case 'updatingRemoteAccess': return 'UPDATE_SERVICE_REMOTEACCESS'
          case 'updatingServices': return 'UPDATE_SERVICE_SERVICES'
        }
        return null
      },
      scrolling() {
        return this.mode !== 'updatingLogProvider'
      },
      isRestricted() {
        return (this.mode === 'updatingLogProvider') && !this.account.limits.logProvider
      },
    },
    methods: {
      open(entity, mode = 'updating', onOpen) {
        this.visible = true
        this.newMode = mode
        this.entity = cloneDeep(entity)
        if (onOpen) {
          this.$nextTick(onOpen)
        }
      },
      onSuccess() {
        this.close()
        utils.reachGoal(`${this.goalPrefix}_SUCCESS`)
      },
      onFail() {
        utils.reachGoal(`${this.goalPrefix}_FAIL`)
      },
    },
    created() {
      this.$modals.updateService = this
    },
  }
</script>
